import { getTabindex } from './get-tabindex';

/**
 * Determines whether the given element uses `tabindex` attribute with negative value
 */
export function hasNegativeTabIndex(element: Element): boolean {
  return getTabindex(element) === -1;
}
